/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Invalid_ValueInputs */

const en_issue_invalid_value = /** @type {(inputs: Issue_Invalid_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has a value the destination system does not accept`)
};

/**
* | output |
* | --- |
* | "has a value the destination system does not accept" |
*
* @param {Issue_Invalid_ValueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_invalid_value = /** @type {((inputs?: Issue_Invalid_ValueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Invalid_ValueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_invalid_value(inputs)
});